import React from "react";
export default function PhysicalAdopt({data}) {
  return (
    <>
      <section className="physical-adopt-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="physical-adopt-box">
                <img src={data?.firstimg} className="physical-blur" alt="Blur"/>
                <div className="physical-adopt-intro">
                  <img src={data?.secondimg} alt="Double Quotes" />
                  <img src={data?.thirdimg} alt="Physical Adopt Intro" />
                  <div>
                    <span>{data?.name}</span>
                    <small>{data?.position}</small>
                  </div>
                </div>
                <p>{data?.desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}